import { axios } from 'lib/axios';

export const smsOTPLogin = async () => {
  return await axios.get('/user/sms/sendCode');
};
